import React, { Fragment } from 'react';
import { Box } from '@mui/material';
import VersionDisplay from './VersionDisplay';

export default function SidebarFooter() {
  return (
    <Fragment>
      <Box className="app-sidebar-footer-wrapper">
        <VersionDisplay />
      </Box>
    </Fragment>
  );
}
